export default __webpack_public_path__ + "4ceee915199ab595ee5ac98ae3c69113.png";